module.exports = __webpack_public_path__ + "img/smf_question_creation.91f1bb19.png";